import { ImageSlider } from '../building-blocks/building-blocks';

import '../../common/css/style.css';

// • Фото та відео з занять, виступів, конкурсів
// • Відгуки батьків і учнів у форматі карток

export const Gallery = () => {
  return (
    <div id="gallery" className="main-style">
      <div className="section-wrapper">
        <h2 className="container-title">Галерея 📸</h2>
        <ImageSlider />
      </div>
    </div>
  );
};
